import React from 'react';

const Swoosh = ({ color }) => {
  return (
    <div className="related-careers-swoosh">
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        height="200px"
        width="300px"
        viewBox="0 0 1080 1080"
        fill={color}
      >
        <path
          className="st0"
          d="M917.5,1072.7C729.7,1054.2,548,971.5,413.5,837C196.2,619.6,119.7,298.6,215.2,6.7c0.3-1,0.6-1.9,0.9-2.9l0,0
	c0.2-0.7,1.2-3.8,1.2-3.8h-12.6c-0.7,2.2-1.5,4.4-2.2,6.7C188.1,51,177.7,96.5,171,142.6c-65,452.6,249.2,872.2,701.8,937.2
	C871.4,1081.4,918.6,1074.3,917.5,1072.7z"
        />
      </svg>
    </div>
  );
};

export default Swoosh;
